import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { AccountCircleOutlined } from '@mui/icons-material';

export default function Dropdown({ onClick }) {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="menu-positioned-button"
        aria-controls={open ? 'menu-position' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <AccountCircleOutlined sx={{ fontSize: '35px',color:"white" }} />
      </Button>
      <Menu
        id="menu-position"
        aria-labelledby="menu-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          mt: "50px"
        }}
      >
        <MenuItem onClick={onClick}>Sign Out</MenuItem>
      </Menu>
    </div>
  );
}
